import { httpClient } from '@/infra/protocols/http';
import { IEpisodeDTO } from '@/modules/episodes/dtos/episode.dto';
import { IEpisode } from '@/modules/episodes/entities/episode.entity';
import { EpisodeMapper } from '@/modules/episodes/mappers/episode.mapper';

export async function updateEpisode(
  params: UpdateEpisodeService.Params,
  data: UpdateEpisodeService.Payload,
): Promise<UpdateEpisodeService.Response> {
  const body = {
    titulo: data.name,
    imagem: data.fileName,
    descricao: data.description,
  };

  const response = await httpClient.put<IEpisodeDTO>(
    `/v1/projetos/${params.projectId}/podcasts/${params.podcastId}/episodios/${params.episodeId}`,
    body,
  );
  return EpisodeMapper.toPresentation(response);
}

export namespace UpdateEpisodeService {
  export interface Payload {
    name: string;
    fileName?: string;
    description: string;
  }

  export type Response = IEpisode;

  export interface Params {
    projectId: string;
    podcastId: string;
    episodeId: number;
  }
}
